<ng-container *ngIf="IsModalOpen | async" [ngTemplateOutlet]="currentTemplate"
    [ngTemplateOutletContext]="{$implicit: {lead: (leadModel | async), dialEnabled: dialEnabled, dialCall: dialCall, direction: direction }}">
</ng-container>

<ng-template #Hubspot let-contact>
    <div class="container">
        <div class="overlay show">
            <div class="popup-partition">
                <div class="partition">
                    <div class="header">
                        {{ (direction | async ) == 0 ? 'Inbound': 'Outbound' }}
                    </div>
                    <div class="body">
                        <div class="profile bottom-gap3">
                            <div class="dial-profile">
                                <div class="group">
                                    <div class="image">
                                        <i class="fa-thin fa-user-vneck-hair"></i>
                                    </div>
                                    <div class="name-card">
                                        <div class="name">{{contact.lead['FirstName'] ?? ''}} {{contact.lead['LastName']
                                            ?? ''}}
                                        </div>
                                        <a class="email">{{contact.lead['Email'] ?? ''}}</a>
                                    </div>
                                </div>
                                <div *ngIf="(direction | async) != 0 " class="action">
                                    <a (click)="dialCall()" [ngClass]="{'disabled' :!(dialEnabled | async) }"
                                        class="btn-capsule">
                                        Dial {{ (count | async ) ? (count | async): '' }}
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="flex-row flex-row--no-pad">
                            <div class="flex-col-sm-6">
                                <div class="user-details">
                                    <div class="icon">
                                        <i class="fa-thin fa-building"></i>
                                    </div>
                                    <div class="name-value">
                                        <div class="name">Company Name</div>
                                        <div class="value">{{contact.lead['Company'] ?? ''}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-col-sm-6">
                                <div class="user-details">
                                    <div class="icon">
                                        <i class="fa-thin fa-building"></i>
                                    </div>
                                    <div class="name-value">
                                        <div class="name">Industry</div>
                                        <div class="value">{{contact.lead['Industry'] ?? ''}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-col-sm-6">
                                <div class="user-details">
                                    <div class="icon">
                                        <i class="fa-thin fa-globe"></i>
                                    </div>
                                    <div class="name-value">
                                        <div class="name">Country</div>
                                        <div class="value">{{contact.lead['Country'] ?? ''}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-col-sm-6">
                                <div class="user-details">
                                    <div class="icon">
                                        <i class="fa-thin fa-square"></i>
                                    </div>
                                    <div class="name-value">
                                        <div class="name">Number of Kits</div>
                                        <div class="value">{{contact.lead['NumberOfKits'] ?? ''}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-col-sm-6">
                                <div class="user-details">
                                    <div class="icon">
                                        <i class="fa-thin fa-user-group"></i>
                                    </div>
                                    <div class="name-value">
                                        <div class="name">Company Size</div>
                                        <div class="value">{{contact.lead['CompanySize'] ?? ''}}</div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="flex-col-sm-6">
                                <div class="user-details">
                                    <div class="icon">
                                        <i class="fa-thin fa-square"></i>
                                    </div>
                                    <div class="name-value">
                                        <div class="name">Untitled</div>
                                        <div class="value">Numbers</div>
                                    </div>
                                </div>
                            </div> -->
                            <div class="flex-col-sm-6">
                                <div class="user-details">
                                    <div class="icon">
                                        <i class="fa-thin fa-calendar"></i>
                                    </div>
                                    <div class="name-value">
                                        <div class="name">Submission Date</div>
                                        <div class="value">{{contact.lead['CreatedDate'] ?? ''}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-col-sm-6">
                                <div class="user-details">
                                    <div class="icon">
                                        <i class="fa-thin fa-phone"></i>
                                    </div>
                                    <div class="name-value">
                                        <div class="name">Dial Count</div>
                                        <div class="value">{{contact.lead['DialCount'] ?? '0'}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="partition --secondary">
                    <div class="header">
                        Question & Answer
                    </div>
                    <div class="body">
                        <div class="chat__conversation-board --secondary">
                            <ng-scrollbar track="all" visibility="hover" style="height: 300px;">

                                <ng-container *ngFor="let question of contact.lead.Questions">
                                    <div class="chat__conversation-board__message-container">
                                        <div class="chat__conversation-board__message__context">
                                            <div class="chat__conversation-board__message__bubble">
                                                <div class="chat__conversation-board__message__person__initial">
                                                    Q
                                                </div>
                                                <p>{{question.ques}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="chat__conversation-board__message-container reversed">
                                        <div class="chat__conversation-board__message__context">
                                            <div class="chat__conversation-board__message__bubble">
                                                <div class="chat__conversation-board__message__person__initial">
                                                    A
                                                </div>
                                                <p>{{question.ans ?? 'N/A'}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-scrollbar>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #Ziply let-contact>
    <div class="container">
        <div class="overlay show">
            <div class="popup-partition --simple">
                <div class="partition">
                    <div class="header">
                        {{ (direction | async ) == 0 ? 'Inbound': 'Outbound' }}
                    </div>
                    <div class="body">
                        <div class="profile bottom-gap4">

                            <div class="dial-profile">
                                <div class="group">
                                    <div class="image">
                                        <i class="fa-thin fa-user-vneck-hair"></i>
                                    </div>
                                    <div class="name-card">
                                        <div class="name">{{contact.lead['FirstName'] ?? ''}} {{contact.lead['LastName']
                                            ?? ''}}
                                        </div>
                                        <a class="email">{{contact.lead['Email'] ?? ''}}</a>
                                        <div class="name blink_me" *ngIf="contact.lead?.IsFrontDesk">Front Desk Lead</div>
                                    </div>
                                </div>
                                <div class="action">
                                    <a (click)="dialCall()" [ngClass]="{'disabled' :!(dialEnabled | async) }"
                                        class="btn-capsule"> Dial {{ (count | async ) ? (count | async): '' }}</a>
                                </div>
                            </div>
                        </div>
                        <div class="flex-row flex-row--no-pad">
                            <div class="flex-col-xs-6">
                                <div class="user-details">
                                    <div class="icon">
                                        <i class="fa-thin fa-building"></i>
                                    </div>
                                    <div class="name-value">
                                        <div class="name">Company Name</div>
                                        <div class="value">{{contact.lead['Company'] ?? ''}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-col-xs-6">
                                <div class="user-details">
                                    <div class="icon">
                                        <i class="fa-thin fa-calendar"></i>
                                    </div>
                                    <div class="name-value">
                                        <div class="name">Name</div>
                                        <div class="value">{{contact.lead['FirstName'] ?? ''}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-col-xs-6">
                                <div class="user-details">
                                    <div class="icon">
                                        <i class="fa-thin fa-building"></i>
                                    </div>
                                    <div class="name-value">
                                        <div class="name">Job Title</div>
                                        <div class="value">{{contact.lead['JobTitle'] ?? ''}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-col-xs-6">
                                <div class="user-details">
                                    <div class="icon">
                                        <i class="fa-thin fa-globe"></i>
                                    </div>
                                    <div class="name-value">
                                        <div class="name">Country</div>
                                        <div class="value">{{contact.lead['Country'] ?? ''}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-col-xs-6">
                                <div class="user-details">
                                    <div class="icon">
                                        <i class="fa-thin fa-address-card"></i>
                                    </div>
                                    <div class="name-value">
                                        <div class="name">Primary Interest</div>
                                        <div class="value">{{contact.lead['PrimaryInterest'] ?? ''}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-col-xs-6">
                                <div class="user-details">
                                    <div class="icon">
                                        <i class="fa-thin fa-user-group"></i>
                                    </div>
                                    <div class="name-value">
                                        <div class="name">Account Owner</div>
                                        <div class="value">{{contact.lead['AccountOwner'] ?? ''}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-col-xs-6">
                                <div class="user-details">
                                    <div class="icon">
                                        <i class="fa-thin fa-file-lines"></i>
                                    </div>
                                    <div class="name-value">
                                        <div class="name">Description</div>
                                        <div class="value">{{contact.lead['Description'] ?? ''}}</div>
                                    </div>
                                </div>
                            </div>  
                            <div class="flex-col-xs-6">
                                <div class="user-details">
                                    <div class="icon">
                                        <i class="fa-thin fa-file-lines"></i>
                                    </div>
                                    <div class="name-value">
                                        <div class="name">Dial Count</div>
                                        <div class="value">{{contact.lead['DialCount'] ?? '0'}}</div>
                                    </div>
                                </div>
                            </div>                          
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</ng-template>
<ng-template #TikTok let-contact>
    <div class="container">
        <div class="overlay show">
            <div class="popup-partition --simple">
                <div class="partition">
                    <div class="header">
                        {{ (direction | async ) == 0 ? 'Inbound': 'Outbound' }}
                    </div>
                    <div class="body">
                        <div class="profile bottom-gap4">

                            <div class="dial-profile">
                                <div class="group">
                                    <div class="image">
                                        <i class="fa-thin fa-user-vneck-hair"></i>
                                    </div>
                                    <div class="name-card">
                                        <div class="name">{{contact.lead['FirstName'] ?? ''}} {{contact.lead['LastName']
                                            ?? ''}}
                                        </div>
                                        <a class="email">{{contact.lead['Email'] ?? ''}}</a>
                                    </div>
                                </div>
                                <div class="action">
                                    <a (click)="dialCall()" [ngClass]="{'disabled' :!(dialEnabled | async) }"
                                        class="btn-capsule"> Dial {{ (count | async ) ? (count | async): '' }}</a>
                                </div>
                            </div>
                        </div>
                        <div class="flex-row flex-row--no-pad">
                          
                            <div class="flex-col-xs-6">
                                <div class="user-details">
                                    <div class="icon">
                                        <i class="fa-thin fa-user"></i>
                                    </div>
                                    <div class="name-value">
                                        <div class="name">Name</div>
                                        <div class="value">{{contact.lead['FirstName'] ?? ''}}</div>
                                    </div>
                                </div>
                            </div>
                       
                            <div class="flex-col-xs-6">
                                <div class="user-details">
                                    <div class="icon">
                                        <i class="fa-thin fa-file-lines"></i>
                                    </div>
                                    <div class="name-value">
                                        <div class="name">Dial Count</div>
                                        <div class="value">{{contact.lead['DialCount'] ?? '0'}}</div>
                                    </div>
                                </div>
                            </div>   
                            
                            <div class="flex-col-xs-6">
                                <div class="user-details">
                                    <div class="icon">
                                        <i class="fa-thin fa-file-lines"></i>
                                    </div>
                                    <div class="name-value">
                                        <div class="name">Source</div>
                                        <div class="value">TikTok</div>
                                    </div>
                                </div>
                            </div>  

                            <div class="flex-col-xs-6">
                                <div class="user-details">
                                    <div class="icon">
                                        <i class="fa-thin fa-globe"></i>
                                    </div>
                                    <div class="name-value">
                                        <div class="name">Country</div>
                                        <div class="value">{{contact.lead['CountryCode'] ?? ''}}</div>
                                    </div>
                                </div>
                            </div> 

                            <div class="flex-col-xs-6">
                                <div class="user-details">
                                    <div class="icon">
                                        <i class="fa-thin fa-calendar"></i>
                                    </div>
                                    <div class="name-value">
                                        <div class="name">Created</div>
                                        <div class="value">{{contact.lead['CreatedDate'] ?? ''}}</div>
                                    </div>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</ng-template>